import { http } from '../utils';

export const fetchBlob = (url) => http.get(url, { responseType: 'blob' });
